import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "copyPriceWindowModal",
  tabindex: "-1",
  "aria-labelledby": "copyPriceWindowModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content text-start" }
const _hoisted_4 = { class: "modal-body text-start" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "copy-from" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { value: "-1" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = { class: "adjustment-info" }
const _hoisted_13 = {
  key: 0,
  class: "mb-3 ms-3"
}
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = { class: "modal-footer text-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "modal-header" }, [
          _createElementVNode("i", { class: "fa fa-copy fa-lg action-icon icon-margin" }),
          _createElementVNode("h5", {
            class: "modal-title",
            id: "copyPriceWindowModalLabel"
          }, " Copy Price Window Settings "),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            "data-bs-dismiss": "modal",
            "aria-label": "Close"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", null, [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("label", { class: "title" }, " Copy from Price Window: ", -1)),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.copyFrom), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("label", { class: "title" }, " Copy to Price Window: ", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedPricingWindow) = $event)),
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleWindowChange && _ctx.handleWindowChange(...args)))
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPricingWindows, (window, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: index,
                    value: window.id
                  }, _toDisplayString(window.name || ''), 9, _hoisted_8))
                }), 128)),
                _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.createNewPricingWindow), 1)
              ], 544), [
                [_vModelSelect, _ctx.selectedPricingWindow]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "title" }, " Modify the price adjustment percentage by this amount: ", -1)),
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  type: "number",
                  value: "0",
                  min: "1",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.priceAdjustmentValue) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.priceAdjustmentValue]
                ]),
                _cache[7] || (_cache[7] = _createElementVNode("span", { class: "input-group-text" }, "%", -1))
              ]),
              _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.adjustmentInfo), 1)
            ])
          ])
        ]),
        (_ctx.strategyType === 3)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _withDirectives(_createElementVNode("input", {
                  class: "form-check-input",
                  type: "checkbox",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.keepExistingWindows) = $event)),
                  id: "keepExistingWindows"
                }, null, 512), [
                  [_vModelCheckbox, _ctx.keepExistingWindows]
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("label", {
                  class: "form-check-label ms-2",
                  for: "keepExistingWindows"
                }, " Keep existing time windows. ", -1)),
                _cache[10] || (_cache[10] = _createElementVNode("i", { class: "fa fa-info-circle info-icon keep-existing-windows-info ms-1" }, null, -1))
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _cache[11] || (_cache[11] = _createElementVNode("button", {
            type: "button",
            class: "btn btn-secondary",
            "data-bs-dismiss": "modal"
          }, " Cancel ", -1)),
          _createElementVNode("button", {
            type: "button",
            class: "btn btn-primary",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.copyPriceWindow && _ctx.copyPriceWindow(...args)))
          }, " Copy ")
        ])
      ])
    ])
  ]))
}